import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityNotice = () => {
  return (
    <div className="bg-primary/5 border border-primary/20 rounded-lg p-6">
      <div className="flex items-start gap-4">
        <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
          <Icon name="Shield" size={20} color="var(--color-primary)" />
        </div>
        <div className="flex-1">
          <h3 className="text-base font-heading font-semibold text-foreground mb-2">
            Sicherheitshinweise
          </h3>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li className="flex items-start gap-2">
              <Icon name="Check" size={16} color="var(--color-success)" className="flex-shrink-0 mt-0.5" />
              <span>Alle Daten werden verschlüsselt übertragen und gespeichert</span>
            </li>
            <li className="flex items-start gap-2">
              <Icon name="Check" size={16} color="var(--color-success)" className="flex-shrink-0 mt-0.5" />
              <span>Sie können nur Gutscheine Ihres Partners verifizieren</span>
            </li>
            <li className="flex items-start gap-2">
              <Icon name="Check" size={16} color="var(--color-success)" className="flex-shrink-0 mt-0.5" />
              <span>Session-Timeout nach 30 Minuten Inaktivität</span>
            </li>
            <li className="flex items-start gap-2">
              <Icon name="Check" size={16} color="var(--color-success)" className="flex-shrink-0 mt-0.5" />
              <span>Alle Verifizierungen werden protokolliert</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SecurityNotice;